<template>
<div id="container">

	<header id="header" class="navbar navbar-default navbar-static-top">
		<div class="container-fluid">
			<div class="navbar-header">
				<h1 style="white-space: nowrap;">{{ $t("app.title") }}<img src="/network/static/img/sun.png" alt="FEN" title="FEN" height="40" /></h1>
			</div>
		</div>
	</header>

	<!-- Sidebar Menu -->
	<nav id="column-left">
		<ul id="menu">
			<template v-if="$user.familyUser">
				<li v-for="(menuItem,key) in $config.basicLists.menuItems" :id="key">
					<router-link :to="menuItem.link" class="text-nowrap" data-toggle="tooltip" data-placement="right" :title="menuItem.title">
						<i class="fa fa-fw" :class="menuItem.icon"></i>&nbsp;<span>{{menuItem.title}}</span>
					</router-link>
				</li>
			</template>

			<li id="admin" v-if="$user.role === 'admin' || $user.role === 'moderator'">
				<a class="parent" data-toggle="tooltip" data-placement="right" title="Администрация"><i class="fa fa-wrench fa-fw"></i> <span>Администрация</span></a>
				<ul>
					<li>
						<router-link to="/moderate/registration/list" data-toggle="tooltip" data-placement="right" title="Регистрации">
							<i class="fa fa-users fa-fw"></i><span>Регистрации</span>
						</router-link>
					</li>
					<li>
						<router-link to="/moderate/category/list" data-toggle="tooltip" data-placement="right" title="Категории">
							<i class="fa fa-tree fa-fw"></i><span>Категории</span>
						</router-link>
					</li>
					<li>
						<router-link to="/moderate/section/list" data-toggle="tooltip" data-placement="right" title="Секции">
							<i class="fa fa-list fa-fw"></i><span>Секции</span>
						</router-link>
					</li>
				</ul>
			</li>

			<li id="exit">
				<router-link to="/logout" data-toggle="tooltip" data-placement="right" title="Изход">
					<i class="fa fa-sign-out fa-fw"></i><span>Изход</span>
				</router-link>
			</li>

		</ul>
	</nav>

	<router-view></router-view>
</div>
</template>

<script>
const $ = require('jquery');
module.exports = {
	name: 'Dash',
	data: function () {
		return {
			section: 'Dash',
			me: '',
			error: '',
			api: {
				servers: {
					url: '', // Back end server
					result: []
				}
			}
		};
	},
	computed: {
		state: function () {
			return {
				userInfo: {
					tasks: [],
					messages: [],
					notifications: []
				}
			};
		},
		callAPI: function () {
			return this.$parent.callAPI;
		},
		year: function () {
			var y = new Date();
			return y.getFullYear();
		}
	},
	methods: {
		toggleMenu: function (event) {
			// remove active from li
			$('li.pageLink').removeClass('active');

			// Add it to the item that was clicked
			event.toElement.parentElement.className = 'pageLink active';
		}
	},
	mounted: function () {
		// Page is ready. Let's load our functions!
	}
};
</script>

<style>
.footer-copyright {
	position: fixed;
	bottom: 0;
	width: 100%;
	/* Set the fixed height of the footer here */
	line-height: 40px;
	background: #EEEEEE;
	border-top: 1px solid #DDDDDD;
	padding: 5px;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?edbe7a9a